import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'trimSurroundingQuotes'
  })
  export class TrimSurroundingQuotesPipe implements PipeTransform {
    transform(values?: string[]): string[] | undefined {
        const quotationChars = [`"`, `'`];
        return values?.map(value => {
            if (!value || !quotationChars.includes(value[0]) || !quotationChars.includes(value[value.length - 1])) {
                return value;
            }
            return value.slice(1, -1);
        });
    }
  }